import { render } from "./MessageHoverActions.vue?vue&type=template&id=458394aa&ts=true"
import script from "./MessageHoverActions.ts?vue&type=script&lang=ts&external"
export * from "./MessageHoverActions.ts?vue&type=script&lang=ts&external"

import "./MessageHoverActions.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__